class MobileDock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const header = document.querySelector('.shopify-section-header');

    this.isAction = false;
    this.scrollY  = header ? parseInt(header.getBoundingClientRect().bottom) : 0;

    if (Shopify && Shopify.designMode) {
      this.scrollY = 0;
    }

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    document.addEventListener('menudrawer:close', this.hideStickyHeader.bind(this));
    document.addEventListener('searchmodal:close', this.hideStickyHeader.bind(this));

    // React to drawer open/close to control dock visibility globally
    this.updateDockVisibility = () => {
      if (this.isAnyDrawerOpen()) {
        this.classList.add('mobile-dock--hidden');
        this.classList.remove('is-active');
        document.documentElement.style.setProperty('--mobile-dock-height', '0px');
      } else {
        this.classList.remove('mobile-dock--hidden');
        this.classList.add('is-active');
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      }
    };

    // Handle cart drawer open/close to hide/show dock so the drawer can occupy full height
    this.onMiniCartOpen = () => {
      this.classList.add('mobile-dock--hidden');
      this.classList.remove('is-active');
      document.documentElement.style.setProperty('--mobile-dock-height', '0px');
    };
    this.onMiniCartClose = () => {
      this.classList.remove('mobile-dock--hidden');
      this.classList.add('is-active');
      document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      // Re-evaluate active state after showing again
      this.onScrollHandler();
    };
    document.addEventListener('mini-cart:open', this.onMiniCartOpen);
    document.addEventListener('mini-cart:close', this.onMiniCartClose);
    // If theme emits open events for other drawers, handle them
    document.addEventListener('menudrawer:open', this.updateDockVisibility);
    document.addEventListener('searchmodal:open', this.updateDockVisibility);
    document.addEventListener('menudrawer:close', this.updateDockVisibility);
    document.addEventListener('searchmodal:close', this.updateDockVisibility);

    // Initial state
    this.updateDockVisibility();

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();

    document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    document.addEventListener('matchSmall', () => {
      document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    document.removeEventListener('mini-cart:open', this.onMiniCartOpen);
    document.removeEventListener('mini-cart:close', this.onMiniCartClose);
    document.removeEventListener('menudrawer:open', this.updateDockVisibility);
    document.removeEventListener('searchmodal:open', this.updateDockVisibility);
    document.removeEventListener('menudrawer:close', this.updateDockVisibility);
    document.removeEventListener('searchmodal:close', this.updateDockVisibility);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.isAnyDrawerOpen()) {
      this.classList.remove('is-active');
      this.classList.add('mobile-dock--hidden');
      return;
    }
    if (scrollTop >= this.scrollY) {
      this.classList.add('is-active');
    }
    else {
      this.classList.remove('is-active');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const delay = this.waitStickyHeader();

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;

        const miniCart = document.querySelector('mini-cart');
        if (miniCart) {
          setTimeout(() => {
            miniCart.open();
            document.activeElement.blur();
          }, delay);
        }
        else {
          window.location.href = theme.routes.cart_url;
        }
        break;

      case 'menu':
        this.isAction = true;

        const headerDrawer = document.querySelector('header-drawer');
        if (headerDrawer) {
          setTimeout(() => {
            headerDrawer.openMenuDrawer();
          }, delay);
        }
        break;

      case 'search':
        this.isAction = true;
        
        const searchModals = document.querySelectorAll('search-modal');
        if (searchModals.length > 0) {
          searchModals.forEach((searchModal) => {
            const style = window.getComputedStyle(searchModal);
            if (style.display === 'none') {
              return;
            }
  
            setTimeout(() => {
              searchModal.open();
              searchModal.querySelector('input:not([type="hidden"])').focus();
            }, delay);
          });
        }
        else {
          window.location.href = theme.routes.search_url;
        }
        break;
    }
  }

  hideStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (theme.config.mqlSmall && this.isAction && header.sticky()) {
      setTimeout(() => {
        header.hide();
        this.isAction = false;
      }, 500);
    }
  }

  waitStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (!header.sticky() && !this.isElementVisible(header)) {
      header.hide();
      setTimeout(() => header.reveal());

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    // Return true if any of its four corners are visible
    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }

  // Returns true if any UI drawer/modal is open
  isAnyDrawerOpen() {
    if (document.body.classList.contains('overflow-hidden')) return true; // common modal pattern
    if (document.querySelector('mini-cart[open]')) return true;
    if (document.querySelector('header-drawer[open]')) return true;
    if (document.querySelector('search-modal[open]')) return true;
    if (document.querySelector('modal-dialog[open]')) return true;
    return false;
  }
}
customElements.define('mobile-dock', MobileDock);
